import React from "react";
import { Effect, LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "react-lazy-load-image-component/src/effects/opacity.css";

export interface LazyLoadImageProps {
  alt: string;
  src: string;
  title?: string;
  width?: number | string;
  height?: number | string;
  effect?: Effect;
  wrapperProps?: {
    style?: React.CSSProperties | any;
    [key: string]: any;
  };
  [key: string]: any;
}

const UptimeImage = (props: LazyLoadImageProps) => {
  const {
    key,
    alt,
    src,
    title,
    width,
    height,
    effect = "blur",
    wrapperProps = { style: { transitionDelay: "1s" } },
    style,
    rest
  } = props;

  return (
    <LazyLoadImage
      key={key}
      alt={alt}
      src={src}
      title={title}
      width={width}
      height={height}
      effect={effect}
      wrapperProps={wrapperProps}
      style={style}
      {...rest}
    />
  );
};

export default UptimeImage;